import { useState } from 'react';
import { useNotification } from './useNotification';
import apiService from '../services/api';

const useHospitalsCrud = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { showNotification } = useNotification();

  const addHospital = async (hospitalData) => {
    setIsLoading(true);
    try {
      const response = await apiService.createHospital(hospitalData);
      showNotification('Hôpital ajouté avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de l\'ajout de l\'hôpital:', error);
      showNotification(`Erreur lors de l'ajout de l'hôpital: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const updateHospital = async (id, hospitalData) => {
    setIsLoading(true);
    try {
      const response = await apiService.updateHospital(id, hospitalData);
      showNotification('Hôpital modifié avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la modification de l\'hôpital:', error);
      showNotification(`Erreur lors de la modification de l'hôpital: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  const deleteHospital = async (id) => {
    setIsLoading(true);
    try {
      const response = await apiService.deleteHospital(id);
      showNotification('Hôpital supprimé avec succès!', 'success');
      return { success: true, data: response };
    } catch (error) {
      console.error('Erreur lors de la suppression de l\'hôpital:', error);
      showNotification(`Erreur lors de la suppression de l'hôpital: ${error.message}`, 'error');
      return { success: false, error };
    } finally {
      setIsLoading(false);
    }
  };

  return {
    addHospital,
    updateHospital,
    deleteHospital,
    isLoading
  };
};

export { useHospitalsCrud };
export default useHospitalsCrud;
